import ImageLink from "../../../../image-link/ImageLink.js"

export default function BookImage({book, showLink=true}) {
	
   const imageAlt = book.bookName + " cover art"
	const pathToPage = showLink ? "/books/" + book.bookName.toLowerCase() : "";
	console.log(pathToPage)
	return (
		
            <div className="book-image">
               <ImageLink imageAlt={imageAlt} image={book.coverImage} link={pathToPage} hasShadow hasBackground={false} hasLink />
            </div>
	)
}
